
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _403e53jXqI3Tj16JtUBelLvU1Gct6KXQd5dBMg_45Yu3GDKwMeta } from "/vercel/path0/pages/403.vue?macro=true";
import { default as _4044jEoyhM5D4gpl_RRiBbkgnQzteY7NWoRqojXN9e6aQsMeta } from "/vercel/path0/pages/404.vue?macro=true";
import { default as debugI_45QvvWa932qo4ck4pkKimMLzswQoFM11sIHH7JqcxboMeta } from "/vercel/path0/pages/debug.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as index4TjtODgoUrynI_JdWzX3UI0NgnXSYz3Tuto6q1hfVWkMeta } from "/vercel/path0/pages/faq/index.vue?macro=true";
import { default as forbiddenKAZp9ibCog2UyAHop_453Zqf_458ucDMYfowkWb1TH7LkvEMeta } from "/vercel/path0/pages/forbidden.vue?macro=true";
import { default as indexQ_45Bs0u3tUANMVZdcHcyLh__45O47WIeUcVIV3xx0OI2EgMeta } from "/vercel/path0/pages/cart/index.vue?macro=true";
import { default as indexy4anpwv8RgJL1xsHEkIFeeBFrRfb2qJ9ikh9XD7CLAIMeta } from "/vercel/path0/pages/shop/index.vue?macro=true";
import { default as indexUAsF7yWTDSMs311V1ch5Q9SzY6oik6jWUewVzVsL7qIMeta } from "/vercel/path0/pages/user/index.vue?macro=true";
import { default as index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as _91slug_934o_45rQSIjW5TT1jKuJyfkKnaWdCPEe2Hm_45IHWKC0XReoMeta } from "/vercel/path0/pages/book/[slug].vue?macro=true";
import { default as indexTXN6JGm_AY0VyMwGtLjKr4MlvEXK0wdis0nr6cuoBkkMeta } from "/vercel/path0/pages/books/index.vue?macro=true";
import { default as indexu7AIOSmfVCn3W1sr14MDontg_45vbQ8zJ1Lx9ayrinVKAMeta } from "/vercel/path0/pages/login/index.vue?macro=true";
import { default as indexiILDqAooaVEmyv0UmCkUctzUcRS9_45CdiKAFLhMDitOkMeta } from "/vercel/path0/pages/terms/index.vue?macro=true";
import { default as _91slug_93GxbH8fV8P_rdfFWJhzPj4UsfmdJRF9VL9KZQwePIXa0Meta } from "/vercel/path0/pages/craft/[slug].vue?macro=true";
import { default as indexo1P0BXZ0C1HXWeG7U_45AVBxufQtkUX7kPdDk86PytHIcMeta } from "/vercel/path0/pages/crafts/index.vue?macro=true";
import { default as verify_45emailaMf0QxbZSTr5r9G3yqEBi7FKtkpvv_OHltL9myi3rfAMeta } from "/vercel/path0/pages/verify-email.vue?macro=true";
import { default as indexrpkKtKQIX5aJqxvjwaLi7ljy7PD1Y_45pZ5DXtMDpZ7CQMeta } from "/vercel/path0/pages/blogger/index.vue?macro=true";
import { default as indexdW670_4563LDuILksGHTznS0mHyGjoe6Ar6P3C6d_45G8r0Meta } from "/vercel/path0/pages/contact/index.vue?macro=true";
import { default as _91slug_93vL5T941QHV6B7546_oNIuyXKTm2NOolMkQOK1YTba7sMeta } from "/vercel/path0/pages/course/[slug].vue?macro=true";
import { default as index_453vKzg5pRjiRBJdQDSFFQvm77bmPDSliKHE3myhEzM8Meta } from "/vercel/path0/pages/courses/index.vue?macro=true";
import { default as _91slug_93_45nApRwGqs0T_45aZcOVzjmwKcr1YDQ2mwcJrwqq1jWtlAMeta } from "/vercel/path0/pages/lesson/[slug].vue?macro=true";
import { default as indexr02o5GO0Nl8F8d_45tWacwGPRQoroiDxpAU4Y8UE4LlHgMeta } from "/vercel/path0/pages/privacy/index.vue?macro=true";
import { default as indexV1UddZJYA0ZlY_45F5dQDIveCgVabnj4uxeetUt1qIr2EMeta } from "/vercel/path0/pages/sitemap/index.vue?macro=true";
import { default as indexBwQ5Eqm2dLZmNReL840HO_45_tRYIMQt_454XpBpafISO7QMeta } from "/vercel/path0/pages/student/index.vue?macro=true";
import { default as _91slug_93x83haUPAwqnnXMtsCqs6nHVRv5dGo_45lpZ0u4y2PDL1cMeta } from "/vercel/path0/pages/article/[slug].vue?macro=true";
import { default as index0f8JRB9cR_4501TW1jzlinuL4Z4mObPIqkaQTdKquio18Meta } from "/vercel/path0/pages/articles/index.vue?macro=true";
import { default as indexrAeaNvo4_UieqfyLJemXjAxVVS_45WFTVwHMXSzzQhPnwMeta } from "/vercel/path0/pages/register/index.vue?macro=true";
import { default as indexfASyfYLZgR55h79sj4xJ_3Zfsayoukd227e7yRPtlF8Meta } from "/vercel/path0/pages/services/index.vue?macro=true";
import { default as _91slug_93Nw_5hYip4lr2MB_45MTayzRUzYRe3dkqLt_I__mbGiMXQMeta } from "/vercel/path0/pages/category/[slug].vue?macro=true";
import { default as _91slug_93MqgCskCqlXm4ps_45rKz5NJLUPCQ9aP3RV5n8c_2Ef8ScMeta } from "/vercel/path0/pages/clothing/[slug].vue?macro=true";
import { default as indexhu_45y9avZcKaMIh7lKU2A_45nlmu43oIkLW6M9E3oLgIpAMeta } from "/vercel/path0/pages/clothings/index.vue?macro=true";
import { default as indexLnn4AM8q_AIijhqFpAJMuS2sUEK0GiE4bD_456XM6nHuoMeta } from "/vercel/path0/pages/admin/chat/index.vue?macro=true";
import { default as indexhRUhv4IknwmlzogS_LHdlAHH_288wMRsQTC_45X1PpHkEMeta } from "/vercel/path0/pages/contribute/index.vue?macro=true";
import { default as _91slug_93anwYvpB2PfgV_45ywOaxf_45Vtbt_45sBSqftoMRrn0I4Qwk0Meta } from "/vercel/path0/pages/formation/[slug].vue?macro=true";
import { default as indexxoK2A1UDaGwdO9SRSzzfWpj0hpFWhoZomLsKGLEAP0cMeta } from "/vercel/path0/pages/instructor/index.vue?macro=true";
import { default as success8AqZ6_o5ZiVocNGznnJi5quhC1osGe7XX7ZoGbvXkcgMeta } from "/vercel/path0/pages/register/success.vue?macro=true";
import { default as supportHOmfR8FCrNbuloremi_45KP0GR82exVH2IKKAGjfqZtcYMeta } from "/vercel/path0/pages/services/support.vue?macro=true";
import { default as test_45lesson_slugI45sTv8s3az3vnI8Hd1weZvjC1655oANEmuxuX6KTrIMeta } from "/vercel/path0/pages/test-lesson_slug.vue?macro=true";
import { default as _91slug_93KBb5iAx7IdyxAXPiNp9VBE50B6fx4w3NzsjFkPEQ3NQMeta } from "/vercel/path0/pages/user/book/[slug].vue?macro=true";
import { default as index1GwmFl2nyIFB2SELMZukC5vWI0PXews2skIrK_45mQ1FIMeta } from "/vercel/path0/pages/user/books/index.vue?macro=true";
import { default as index7snL9UJ5WLMMYu9u6IIh5rvPHrHKNA_tpciPwCSJ9OEMeta } from "/vercel/path0/pages/admin/users/index.vue?macro=true";
import { default as index_F9EpeRbcC0okdXJHprChuZPCNTOGQBBlZFxxHXWUkcMeta } from "/vercel/path0/pages/contributor/index.vue?macro=true";
import { default as _91slug_93s0JUKBatirRFLLMcaY1lqb26y2HBwqYxaQzrxPanQNIMeta } from "/vercel/path0/pages/stationery/[slug].vue?macro=true";
import { default as indexgJLXXngAXVbQmRICga3oE7i5cOUcQrMysmdVGv7HQCUMeta } from "/vercel/path0/pages/user/crafts/index.vue?macro=true";
import { default as editslafpBDGBWvNYpBW04eiAfSs99Vrpb5bsAx3gD8vv7cMeta } from "/vercel/path0/pages/user/profile/edit.vue?macro=true";
import { default as _91slug_93WHUAg5CTegjwl7Lt8HkcAsoOpaMQ9Vv5xaeIeyR6LCoMeta } from "/vercel/path0/pages/author/book/[slug].vue?macro=true";
import { default as indexftNygCQ2b0gE47tUJecksQccFUIfOzOZCneuQJBAX4EMeta } from "/vercel/path0/pages/author/books/index.vue?macro=true";
import { default as coursesDescriptionexx23etzlG559_457nknCLqzxXmVWrbwTTm31KViydEfIMeta } from "/vercel/path0/pages/coursesDescription.vue?macro=true";
import { default as _91username_93OVUsmQq3OLiEUZQ4t4rk1Kb6LhIKOA6IJczu9NIRlhcMeta } from "/vercel/path0/pages/profile/[username].vue?macro=true";
import { default as creationswg1A09CXENCvCH4RqLWd_vjjNNijBHqRYCKquXuUrrkMeta } from "/vercel/path0/pages/services/creations.vue?macro=true";
import { default as checkoutzYLvYtVp04deixgql6sDtGb0cqX0_45BktsKg6_457k3qaUMeta } from "/vercel/path0/pages/shop/cart/checkout.vue?macro=true";
import { default as indexg7Edx1xDWx9wCGyxTULyTQ7pNNSDtQxE787s2hNvMT8Meta } from "/vercel/path0/pages/stationeries/index.vue?macro=true";
import { default as _91slug_934aWT25qBIo2rH997Ypas9jP3_45HRVns29zM6wXXvpNP0Meta } from "/vercel/path0/pages/user/course/[slug].vue?macro=true";
import { default as index45OfQBw3Zj1AMO7Qo8w5R__457b_OAC04Zf_454JCYoYDFMMeta } from "/vercel/path0/pages/user/courses/index.vue?macro=true";
import { default as _91slug_93B8P3FfNH5rzzw4t5VdqW_fO4HIKLc8AjT3DXtO0bwLoMeta } from "/vercel/path0/pages/user/lesson/[slug].vue?macro=true";
import { default as certificateJ4HK2bAE6YDcRidZFI170sp9dfgbyanLa_45k_45WSUScfMMeta } from "/vercel/path0/pages/verify/certificate.vue?macro=true";
import { default as indexqICVgZYrhVQArh2MyNdsy6TweaTJ8Vo_rjqrPl5_45bNsMeta } from "/vercel/path0/pages/admin/courses/index.vue?macro=true";
import { default as _91slug_93isIzUeopnXdkfdwsQ_mTmNoqP4HGKUBYqKk3n41owjEMeta } from "/vercel/path0/pages/author/craft/[slug].vue?macro=true";
import { default as indexTvOsRvnyzfPRYfc3QspyB3abAMKADvnLzKEWJpkVZx8Meta } from "/vercel/path0/pages/author/crafts/index.vue?macro=true";
import { default as indexnhVzbg9xET6_45Xr1Eb06l2YzaVpqJDEHC_3ImzgGrREQMeta } from "/vercel/path0/pages/documentation/index.vue?macro=true";
import { default as formationsoG4WATel58nEyXzWrVMGjgaQgeNmIytnEmrc5VysMxkMeta } from "/vercel/path0/pages/services/formations.vue?macro=true";
import { default as _91slug_93IkGTUcllQW0JZiZeTeJ16ZsWVk4ld8qM2NUD7kNFJiYMeta } from "/vercel/path0/pages/shop/article/[slug].vue?macro=true";
import { default as _91slug_931TIJCf3WQmyDzIkLrK7yvfQ2NN_45PeE6vYm9mTc44ItwMeta } from "/vercel/path0/pages/student/quiz/[slug].vue?macro=true";
import { default as indexjWaHK4FKOAJehXoKnjOs91VI4CpDNDO4a5z4EkFsrsUMeta } from "/vercel/path0/pages/user/articles/index.vue?macro=true";
import { default as index1ZcYxuf2DkP1ZCwAnyBOkZN3KqM64Rx_uJ31eXXYNl8Meta } from "/vercel/path0/pages/user/clothing/index.vue?macro=true";
import { default as indexrKAeivYXVeTApB3yFCR2YC4gPhW0SLwxnbsPo3nT9ckMeta } from "/vercel/path0/pages/user/invoices/index.vue?macro=true";
import { default as indexXqu9mLROs10ceWMSwqVgRwLbVi_458eW8mIQj0uUy9YMIMeta } from "/vercel/path0/pages/admin/articles/index.vue?macro=true";
import { default as _91slug_93XQHpBLISlcf2aDH0PB_45vi56wAXrj6Q3YThtqdIvvteIMeta } from "/vercel/path0/pages/author/course/[slug].vue?macro=true";
import { default as indexa03_PhCQ9ejY48pOSUZJ93gVVnAJWqrM0Cftl632jvwMeta } from "/vercel/path0/pages/author/courses/index.vue?macro=true";
import { default as questionsZoh7yMoHOEQCLoyYndwJmnYcDyztyCRH1vdLoa9tmwcMeta } from "/vercel/path0/pages/instructor/questions.vue?macro=true";
import { default as indexhZyh7Y3M_45lzEofTrDBz2Os0GehnTRX_45M67kx1wTsh5QMeta } from "/vercel/path0/pages/reset-password/index.vue?macro=true";
import { default as _91slug_93lThHFgY1dCc2eTps0Dx3YU9AFgXodMgIyJAvQKZ3vzMMeta } from "/vercel/path0/pages/shop/checkout/[slug].vue?macro=true";
import { default as index80GJpfxER9N8ggWq3FMvF2hG_45DCPCneF6odqsOMlEHoMeta } from "/vercel/path0/pages/user/subscribe/index.vue?macro=true";
import { default as _91username_93AHl8XRHw2Q0SlGfLxXN_45N8N_E1SkA7Qu_45fQS4NOZfYMMeta } from "/vercel/path0/pages/admin/user/[username].vue?macro=true";
import { default as _91slug_93WxpHCQw8t_52YuWThwypgHW3cW7Obk9st_45I1Fmvr_m0Meta } from "/vercel/path0/pages/author/article/[slug].vue?macro=true";
import { default as indexrt9Iyn78ItBLFr8iF0w_452OvjFHmqiF5SEAZxkHsfX7oMeta } from "/vercel/path0/pages/author/articles/index.vue?macro=true";
import { default as index2nWaCA3_45zD9pLl9p_4513ShZApcncBw9HYdWwXAYi_YrQMeta } from "/vercel/path0/pages/forgot-password/index.vue?macro=true";
import { default as _91slug_93b96xXZ_45363uoFqRk69izxCFtdavA_45AJvMhgOab3V3XkMeta } from "/vercel/path0/pages/lesson/numeric/[slug].vue?macro=true";
import { default as indexJo1kXUJHqhto1WZjh1mg7kXXlXGBeVjvujTe95h5k74Meta } from "/vercel/path0/pages/payment-success/index.vue?macro=true";
import { default as _91slug_93wd8yl4o5wYJgLQAsUkZ2vU_45_0DY_459EVu7jdoZuMWRacMeta } from "/vercel/path0/pages/student/course/[slug].vue?macro=true";
import { default as indexfMjXdAV00D0ZN3y6tYG0RgDukqcLbd3iHjNs5p_45bzp0Meta } from "/vercel/path0/pages/student/courses/index.vue?macro=true";
import { default as _91slug_93o9HzxEfGr1tZT4qBu3zmCxqZZUJOanffvGvBjYvhvO0Meta } from "/vercel/path0/pages/student/lesson/[slug].vue?macro=true";
import { default as indexDmObyxm98AxkRMMb6YcWqNUf8WctBlCBTIIWYK8WBkUMeta } from "/vercel/path0/pages/student/quizzes/index.vue?macro=true";
import { default as indexQTx_fXp0VZiFarJAz2cAUc99LAc3RX_36t2EZR7aeasMeta } from "/vercel/path0/pages/user/stationery/index.vue?macro=true";
import { default as indexBkr4YHdFkpWK_5UGkU4x7vrTywEhTeTagCFqOy9fz4cMeta } from "/vercel/path0/pages/author/clothings/index.vue?macro=true";
import { default as documentation26k07vAyxxlTL36_45A1N8O2a1h8Mm7TDYQ0mx05XbFxsMeta } from "/vercel/path0/pages/services/documentation.vue?macro=true";
import { default as _91slug_93tD6_8snnRh9a967Rsp9r54eb2i7PJMv6HuLokFwhXGgMeta } from "/vercel/path0/pages/author/edit/book/[slug].vue?macro=true";
import { default as _91slug_93MlBB_dh8VmJGkslc5B1CtCT1Agr_45sSdLfT_ZEOPumNoMeta } from "/vercel/path0/pages/lesson/exercises/[slug].vue?macro=true";
import { default as _91slug_93zWyCq1g0oJyWXvvHDfwXUb1IggVt1pstS5O1lR_45bCfwMeta } from "/vercel/path0/pages/admin/edit/course/[slug].vue?macro=true";
import { default as _91slug_93EaQXV5RpPkTPnc0dsL_45UPLXEVdeUkmaWDdxk2VxpBCYMeta } from "/vercel/path0/pages/admin/edit/lesson/[slug].vue?macro=true";
import { default as indexqUDCiiG7svAzKxkOlyAyC8Z4JQMSi1RUTmx5VxsT2cUMeta } from "/vercel/path0/pages/admin/performances/index.vue?macro=true";
import { default as _91slug_93q6q7DOlXiqjBSUlBswau_PCR7eL3bf_45xBb72lChZn_YMeta } from "/vercel/path0/pages/author/edit/craft/[slug].vue?macro=true";
import { default as _91slug_93AzYQxGox0j8DfSi3Zs_45VvQUDTPAVMeNJRbtvA98JtHkMeta } from "/vercel/path0/pages/author/stationery/[slug].vue?macro=true";
import { default as indexmfJPI1AaAdJszjxgaP52QzA2KgwOMkQb_45iuZnJksExYMeta } from "/vercel/path0/pages/documentation/user/index.vue?macro=true";
import { default as _91slug_931z7ipBmj8MdPvIp2gXF_45DnktW_mTEIVRHMFPXoYKe_45IMeta } from "/vercel/path0/pages/instructor/lesson/[slug].vue?macro=true";
import { default as _91slug_93EMv5yiBHNIzTVWl6jqtYmzhzO4N6mnVpog1aOEfb2gYMeta } from "/vercel/path0/pages/author/edit/course/[slug].vue?macro=true";
import { default as index3FB6k4HsDLwR_45_3gVl8TDWbCOlBeT6Qt97BnnMMv8_45IMeta } from "/vercel/path0/pages/author/stationeries/index.vue?macro=true";
import { default as indexANBoP_1HlEEPQidDjt6bi_JZsPbYgOJ5nXgF462QDm0Meta } from "/vercel/path0/pages/documentation/admin/index.vue?macro=true";
import { default as _91invoice_id_93SoxwBO9GQZHvDvBlBtqS0ArIHS2QpJaJZ7iY1kCZnkgMeta } from "/vercel/path0/pages/user/invoice/[invoice_id].vue?macro=true";
import { default as _91username_93AAS08r_mElNJhMf_xDmzwRTySJhQEk_0yRotlz_qNKwMeta } from "/vercel/path0/pages/admin/edit/user/[username].vue?macro=true";
import { default as _91slug_93bnqsh1QXOByHIJQrhCQ21kvFnqQLQaAddQkgQzeUYVIMeta } from "/vercel/path0/pages/author/edit/article/[slug].vue?macro=true";
import { default as indexapGVLn5BmVx0IIt18BD6JiE2P7RLm_xW53qKomwUaC8Meta } from "/vercel/path0/pages/documentation/author/index.vue?macro=true";
import { default as indexf5WtjKzj4V1xstu_QY3LrLvH1Tycltk8b2RTwQtvf7gMeta } from "/vercel/path0/pages/student/certificates/index.vue?macro=true";
import { default as _91username_93SQOYUyrL0MEOTgNtBn8JwY6UA4b9VOuV_45TpPZ6xuBXUMeta } from "/vercel/path0/pages/student/profile/[username].vue?macro=true";
import { default as indexKutGOtxhH7aJO5vlPjFYRvVXN9GuOj2IjHoP_6w07wsMeta } from "/vercel/path0/pages/documentation/blogger/index.vue?macro=true";
import { default as indexELME5EuEXwEBnSJUjVwGsm_451c1878NOToxu_45zAF13MkMeta } from "/vercel/path0/pages/documentation/creator/index.vue?macro=true";
import { default as indexD3CooIcwXwJ6JyTJ8lQuNLEAbAJdRyzg3fzPMLmOVj4Meta } from "/vercel/path0/pages/documentation/student/index.vue?macro=true";
import { default as indexUY1IoAWaawKB3XOddzBx6vExKYl0VLns9MHrB5aP0JEMeta } from "/vercel/path0/pages/student/notifications/index.vue?macro=true";
import { default as _91username_93dtBnUadmyQZIxCuaxtzCXVC4rZ2tuGCPYV1Vj_lQuKUMeta } from "/vercel/path0/pages/admin/delete/user/[username].vue?macro=true";
import { default as _91slug_93LG5xvkfJDYnYptP469_G5QIjsxXHGxaIY9upwZ_45PTWsMeta } from "/vercel/path0/pages/shop/article/checkout/[slug].vue?macro=true";
import { default as _91slug_93BUmQKCulPbWMuEmJ_qBOgABSaJFQZlsA3EDOirEyk6EMeta } from "/vercel/path0/pages/user/lesson/exercises/[slug].vue?macro=true";
import { default as indexB0MYz1AHu0yJJAgEsh0V7GrDNSp3pEsA790yv5z8gw0Meta } from "/vercel/path0/pages/documentation/instructor/index.vue?macro=true";
import { default as _91slug_93fQ0J_8Wu2TPtkdMLojcA6DtALHy_Fz3fpX3DvEcBbgoMeta } from "/vercel/path0/pages/lesson/virtual-keyboard/[slug].vue?macro=true";
import { default as _91slug_9369jwdZPKRHjDXQeXM_45kkxl6440Qn56g24mxsn5GDYEYMeta } from "/vercel/path0/pages/student/lesson/exercises/[slug].vue?macro=true";
import { default as _91slug_937r_45_Uu3jMEVo0GLp18c7oY_458KpkRwM0_45R892_q5GF_EMeta } from "/vercel/path0/pages/lesson/virtual-calculator/[slug].vue?macro=true";
import { default as _91course_slug_93H05t0UNVpIMqhXZz4kUp87AN7Zr0XSdvlWD6Shix3s4Meta } from "/vercel/path0/pages/student/certificate/[course_slug].vue?macro=true";
import { default as _91slug_93n7ChCBNBnENP2g3fmnystq05RN3bpWL2sWbSeNjgSxEMeta } from "/vercel/path0/pages/lesson/exercises/corrections/[slug].vue?macro=true";
import { default as _91slug_93KQhEr5SOctE_45eR8IT7WUaMOeCYjbcMWbs5dyZGcbUFQMeta } from "/vercel/path0/pages/student/lesson/numeric-keyboard/[slug].vue?macro=true";
import { default as _91slug_93JwWP01sNXoZiRxXPDyhhfx2VDeQcv9TDzfiBoH4EpJAMeta } from "/vercel/path0/pages/student/lesson/virtual-keyboard/[slug].vue?macro=true";
import { default as _91slug_93Om8NC9NrQM8xLEKk6MFdjZsUOxl5NwLsAFNgDYqut_454Meta } from "/vercel/path0/pages/student/lesson/virtual-calculator/[slug].vue?macro=true";
import { default as _91slug_93eNsDAvjAKxltHbnxWMkuTbePnlLOAsygbz_zmC6i3OwMeta } from "/vercel/path0/pages/user/lesson/exercises/corrections/[slug].vue?macro=true";
import { default as _91slug_93LHpkdLlTAzwR15yLGiFA4qCt02SpVi8kgcUF7drKjrkMeta } from "/vercel/path0/pages/student/lesson/exercises/corrections/[slug].vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    component: () => import("/vercel/path0/pages/403.vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/vercel/path0/pages/404.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/vercel/path0/pages/faq/index.vue")
  },
  {
    name: "forbidden",
    path: "/forbidden",
    component: () => import("/vercel/path0/pages/forbidden.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/vercel/path0/pages/cart/index.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "user",
    path: "/user",
    meta: indexUAsF7yWTDSMs311V1ch5Q9SzY6oik6jWUewVzVsL7qIMeta || {},
    component: () => import("/vercel/path0/pages/user/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta || {},
    component: () => import("/vercel/path0/pages/admin/index.vue")
  },
  {
    name: "book-slug",
    path: "/book/:slug()",
    component: () => import("/vercel/path0/pages/book/[slug].vue")
  },
  {
    name: "books",
    path: "/books",
    component: () => import("/vercel/path0/pages/books/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/pages/login/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/vercel/path0/pages/terms/index.vue")
  },
  {
    name: "craft-slug",
    path: "/craft/:slug()",
    component: () => import("/vercel/path0/pages/craft/[slug].vue")
  },
  {
    name: "crafts",
    path: "/crafts",
    component: () => import("/vercel/path0/pages/crafts/index.vue")
  },
  {
    name: "verify-email",
    path: "/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "blogger",
    path: "/blogger",
    meta: indexrpkKtKQIX5aJqxvjwaLi7ljy7PD1Y_45pZ5DXtMDpZ7CQMeta || {},
    component: () => import("/vercel/path0/pages/blogger/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact/index.vue")
  },
  {
    name: "course-slug",
    path: "/course/:slug()",
    component: () => import("/vercel/path0/pages/course/[slug].vue")
  },
  {
    name: "courses",
    path: "/courses",
    component: () => import("/vercel/path0/pages/courses/index.vue")
  },
  {
    name: "lesson-slug",
    path: "/lesson/:slug()",
    component: () => import("/vercel/path0/pages/lesson/[slug].vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/vercel/path0/pages/privacy/index.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/vercel/path0/pages/sitemap/index.vue")
  },
  {
    name: "student",
    path: "/student",
    meta: indexBwQ5Eqm2dLZmNReL840HO_45_tRYIMQt_454XpBpafISO7QMeta || {},
    component: () => import("/vercel/path0/pages/student/index.vue")
  },
  {
    name: "article-slug",
    path: "/article/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug].vue")
  },
  {
    name: "articles",
    path: "/articles",
    component: () => import("/vercel/path0/pages/articles/index.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("/vercel/path0/pages/register/index.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/vercel/path0/pages/services/index.vue")
  },
  {
    name: "category-slug",
    path: "/category/:slug()",
    component: () => import("/vercel/path0/pages/category/[slug].vue")
  },
  {
    name: "clothing-slug",
    path: "/clothing/:slug()",
    component: () => import("/vercel/path0/pages/clothing/[slug].vue")
  },
  {
    name: "clothings",
    path: "/clothings",
    component: () => import("/vercel/path0/pages/clothings/index.vue")
  },
  {
    name: "admin-chat",
    path: "/admin/chat",
    component: () => import("/vercel/path0/pages/admin/chat/index.vue")
  },
  {
    name: "contribute",
    path: "/contribute",
    component: () => import("/vercel/path0/pages/contribute/index.vue")
  },
  {
    name: "formation-slug",
    path: "/formation/:slug()",
    component: () => import("/vercel/path0/pages/formation/[slug].vue")
  },
  {
    name: "instructor",
    path: "/instructor",
    component: () => import("/vercel/path0/pages/instructor/index.vue")
  },
  {
    name: "register-success",
    path: "/register/success",
    component: () => import("/vercel/path0/pages/register/success.vue")
  },
  {
    name: "services-support",
    path: "/services/support",
    component: () => import("/vercel/path0/pages/services/support.vue")
  },
  {
    name: "test-lesson_slug",
    path: "/test-lesson_slug",
    component: () => import("/vercel/path0/pages/test-lesson_slug.vue")
  },
  {
    name: "user-book-slug",
    path: "/user/book/:slug()",
    component: () => import("/vercel/path0/pages/user/book/[slug].vue")
  },
  {
    name: "user-books",
    path: "/user/books",
    component: () => import("/vercel/path0/pages/user/books/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/vercel/path0/pages/admin/users/index.vue")
  },
  {
    name: "contributor",
    path: "/contributor",
    component: () => import("/vercel/path0/pages/contributor/index.vue")
  },
  {
    name: "stationery-slug",
    path: "/stationery/:slug()",
    component: () => import("/vercel/path0/pages/stationery/[slug].vue")
  },
  {
    name: "user-crafts",
    path: "/user/crafts",
    component: () => import("/vercel/path0/pages/user/crafts/index.vue")
  },
  {
    name: "user-profile-edit",
    path: "/user/profile/edit",
    component: () => import("/vercel/path0/pages/user/profile/edit.vue")
  },
  {
    name: "author-book-slug",
    path: "/author/book/:slug()",
    component: () => import("/vercel/path0/pages/author/book/[slug].vue")
  },
  {
    name: "author-books",
    path: "/author/books",
    component: () => import("/vercel/path0/pages/author/books/index.vue")
  },
  {
    name: "coursesDescription",
    path: "/coursesDescription",
    component: () => import("/vercel/path0/pages/coursesDescription.vue")
  },
  {
    name: "profile-username",
    path: "/profile/:username()",
    meta: _91username_93OVUsmQq3OLiEUZQ4t4rk1Kb6LhIKOA6IJczu9NIRlhcMeta || {},
    component: () => import("/vercel/path0/pages/profile/[username].vue")
  },
  {
    name: "services-creations",
    path: "/services/creations",
    component: () => import("/vercel/path0/pages/services/creations.vue")
  },
  {
    name: "shop-cart-checkout",
    path: "/shop/cart/checkout",
    component: () => import("/vercel/path0/pages/shop/cart/checkout.vue")
  },
  {
    name: "stationeries",
    path: "/stationeries",
    component: () => import("/vercel/path0/pages/stationeries/index.vue")
  },
  {
    name: "user-course-slug",
    path: "/user/course/:slug()",
    component: () => import("/vercel/path0/pages/user/course/[slug].vue")
  },
  {
    name: "user-courses",
    path: "/user/courses",
    component: () => import("/vercel/path0/pages/user/courses/index.vue")
  },
  {
    name: "user-lesson-slug",
    path: "/user/lesson/:slug()",
    component: () => import("/vercel/path0/pages/user/lesson/[slug].vue")
  },
  {
    name: "verify-certificate",
    path: "/verify/certificate",
    component: () => import("/vercel/path0/pages/verify/certificate.vue")
  },
  {
    name: "admin-courses",
    path: "/admin/courses",
    meta: indexqICVgZYrhVQArh2MyNdsy6TweaTJ8Vo_rjqrPl5_45bNsMeta || {},
    component: () => import("/vercel/path0/pages/admin/courses/index.vue")
  },
  {
    name: "author-craft-slug",
    path: "/author/craft/:slug()",
    component: () => import("/vercel/path0/pages/author/craft/[slug].vue")
  },
  {
    name: "author-crafts",
    path: "/author/crafts",
    component: () => import("/vercel/path0/pages/author/crafts/index.vue")
  },
  {
    name: "documentation",
    path: "/documentation",
    component: () => import("/vercel/path0/pages/documentation/index.vue")
  },
  {
    name: "services-formations",
    path: "/services/formations",
    component: () => import("/vercel/path0/pages/services/formations.vue")
  },
  {
    name: "shop-article-slug",
    path: "/shop/article/:slug()",
    component: () => import("/vercel/path0/pages/shop/article/[slug].vue")
  },
  {
    name: "student-quiz-slug",
    path: "/student/quiz/:slug()",
    component: () => import("/vercel/path0/pages/student/quiz/[slug].vue")
  },
  {
    name: "user-articles",
    path: "/user/articles",
    component: () => import("/vercel/path0/pages/user/articles/index.vue")
  },
  {
    name: "user-clothing",
    path: "/user/clothing",
    component: () => import("/vercel/path0/pages/user/clothing/index.vue")
  },
  {
    name: "user-invoices",
    path: "/user/invoices",
    component: () => import("/vercel/path0/pages/user/invoices/index.vue")
  },
  {
    name: "admin-articles",
    path: "/admin/articles",
    component: () => import("/vercel/path0/pages/admin/articles/index.vue")
  },
  {
    name: "author-course-slug",
    path: "/author/course/:slug()",
    component: () => import("/vercel/path0/pages/author/course/[slug].vue")
  },
  {
    name: "author-courses",
    path: "/author/courses",
    component: () => import("/vercel/path0/pages/author/courses/index.vue")
  },
  {
    name: "instructor-questions",
    path: "/instructor/questions",
    component: () => import("/vercel/path0/pages/instructor/questions.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/vercel/path0/pages/reset-password/index.vue")
  },
  {
    name: "shop-checkout-slug",
    path: "/shop/checkout/:slug()",
    component: () => import("/vercel/path0/pages/shop/checkout/[slug].vue")
  },
  {
    name: "user-subscribe",
    path: "/user/subscribe",
    component: () => import("/vercel/path0/pages/user/subscribe/index.vue")
  },
  {
    name: "admin-user-username",
    path: "/admin/user/:username()",
    component: () => import("/vercel/path0/pages/admin/user/[username].vue")
  },
  {
    name: "author-article-slug",
    path: "/author/article/:slug()",
    component: () => import("/vercel/path0/pages/author/article/[slug].vue")
  },
  {
    name: "author-articles",
    path: "/author/articles",
    component: () => import("/vercel/path0/pages/author/articles/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/vercel/path0/pages/forgot-password/index.vue")
  },
  {
    name: "lesson-numeric-slug",
    path: "/lesson/numeric/:slug()",
    component: () => import("/vercel/path0/pages/lesson/numeric/[slug].vue")
  },
  {
    name: "payment-success",
    path: "/payment-success",
    component: () => import("/vercel/path0/pages/payment-success/index.vue")
  },
  {
    name: "student-course-slug",
    path: "/student/course/:slug()",
    component: () => import("/vercel/path0/pages/student/course/[slug].vue")
  },
  {
    name: "student-courses",
    path: "/student/courses",
    meta: indexfMjXdAV00D0ZN3y6tYG0RgDukqcLbd3iHjNs5p_45bzp0Meta || {},
    component: () => import("/vercel/path0/pages/student/courses/index.vue")
  },
  {
    name: "student-lesson-slug",
    path: "/student/lesson/:slug()",
    meta: _91slug_93o9HzxEfGr1tZT4qBu3zmCxqZZUJOanffvGvBjYvhvO0Meta || {},
    component: () => import("/vercel/path0/pages/student/lesson/[slug].vue")
  },
  {
    name: "student-quizzes",
    path: "/student/quizzes",
    component: () => import("/vercel/path0/pages/student/quizzes/index.vue")
  },
  {
    name: "user-stationery",
    path: "/user/stationery",
    component: () => import("/vercel/path0/pages/user/stationery/index.vue")
  },
  {
    name: "author-clothings",
    path: "/author/clothings",
    component: () => import("/vercel/path0/pages/author/clothings/index.vue")
  },
  {
    name: "services-documentation",
    path: "/services/documentation",
    component: () => import("/vercel/path0/pages/services/documentation.vue")
  },
  {
    name: "author-edit-book-slug",
    path: "/author/edit/book/:slug()",
    component: () => import("/vercel/path0/pages/author/edit/book/[slug].vue")
  },
  {
    name: "lesson-exercises-slug",
    path: "/lesson/exercises/:slug()",
    component: () => import("/vercel/path0/pages/lesson/exercises/[slug].vue")
  },
  {
    name: "admin-edit-course-slug",
    path: "/admin/edit/course/:slug()",
    meta: _91slug_93zWyCq1g0oJyWXvvHDfwXUb1IggVt1pstS5O1lR_45bCfwMeta || {},
    component: () => import("/vercel/path0/pages/admin/edit/course/[slug].vue")
  },
  {
    name: "admin-edit-lesson-slug",
    path: "/admin/edit/lesson/:slug()",
    meta: _91slug_93EaQXV5RpPkTPnc0dsL_45UPLXEVdeUkmaWDdxk2VxpBCYMeta || {},
    component: () => import("/vercel/path0/pages/admin/edit/lesson/[slug].vue")
  },
  {
    name: "admin-performances",
    path: "/admin/performances",
    component: () => import("/vercel/path0/pages/admin/performances/index.vue")
  },
  {
    name: "author-edit-craft-slug",
    path: "/author/edit/craft/:slug()",
    component: () => import("/vercel/path0/pages/author/edit/craft/[slug].vue")
  },
  {
    name: "author-stationery-slug",
    path: "/author/stationery/:slug()",
    component: () => import("/vercel/path0/pages/author/stationery/[slug].vue")
  },
  {
    name: "documentation-user",
    path: "/documentation/user",
    component: () => import("/vercel/path0/pages/documentation/user/index.vue")
  },
  {
    name: "instructor-lesson-slug",
    path: "/instructor/lesson/:slug()",
    meta: _91slug_931z7ipBmj8MdPvIp2gXF_45DnktW_mTEIVRHMFPXoYKe_45IMeta || {},
    component: () => import("/vercel/path0/pages/instructor/lesson/[slug].vue")
  },
  {
    name: "author-edit-course-slug",
    path: "/author/edit/course/:slug()",
    meta: _91slug_93EMv5yiBHNIzTVWl6jqtYmzhzO4N6mnVpog1aOEfb2gYMeta || {},
    component: () => import("/vercel/path0/pages/author/edit/course/[slug].vue")
  },
  {
    name: "author-stationeries",
    path: "/author/stationeries",
    component: () => import("/vercel/path0/pages/author/stationeries/index.vue")
  },
  {
    name: "documentation-admin",
    path: "/documentation/admin",
    component: () => import("/vercel/path0/pages/documentation/admin/index.vue")
  },
  {
    name: "user-invoice-invoice_id",
    path: "/user/invoice/:invoice_id()",
    component: () => import("/vercel/path0/pages/user/invoice/[invoice_id].vue")
  },
  {
    name: "admin-edit-user-username",
    path: "/admin/edit/user/:username()",
    meta: _91username_93AAS08r_mElNJhMf_xDmzwRTySJhQEk_0yRotlz_qNKwMeta || {},
    component: () => import("/vercel/path0/pages/admin/edit/user/[username].vue")
  },
  {
    name: "author-edit-article-slug",
    path: "/author/edit/article/:slug()",
    component: () => import("/vercel/path0/pages/author/edit/article/[slug].vue")
  },
  {
    name: "documentation-author",
    path: "/documentation/author",
    component: () => import("/vercel/path0/pages/documentation/author/index.vue")
  },
  {
    name: "student-certificates",
    path: "/student/certificates",
    component: () => import("/vercel/path0/pages/student/certificates/index.vue")
  },
  {
    name: "student-profile-username",
    path: "/student/profile/:username()",
    component: () => import("/vercel/path0/pages/student/profile/[username].vue")
  },
  {
    name: "documentation-blogger",
    path: "/documentation/blogger",
    component: () => import("/vercel/path0/pages/documentation/blogger/index.vue")
  },
  {
    name: "documentation-creator",
    path: "/documentation/creator",
    component: () => import("/vercel/path0/pages/documentation/creator/index.vue")
  },
  {
    name: "documentation-student",
    path: "/documentation/student",
    component: () => import("/vercel/path0/pages/documentation/student/index.vue")
  },
  {
    name: "student-notifications",
    path: "/student/notifications",
    component: () => import("/vercel/path0/pages/student/notifications/index.vue")
  },
  {
    name: "admin-delete-user-username",
    path: "/admin/delete/user/:username()",
    component: () => import("/vercel/path0/pages/admin/delete/user/[username].vue")
  },
  {
    name: "shop-article-checkout-slug",
    path: "/shop/article/checkout/:slug()",
    component: () => import("/vercel/path0/pages/shop/article/checkout/[slug].vue")
  },
  {
    name: "user-lesson-exercises-slug",
    path: "/user/lesson/exercises/:slug()",
    component: () => import("/vercel/path0/pages/user/lesson/exercises/[slug].vue")
  },
  {
    name: "documentation-instructor",
    path: "/documentation/instructor",
    component: () => import("/vercel/path0/pages/documentation/instructor/index.vue")
  },
  {
    name: "lesson-virtual-keyboard-slug",
    path: "/lesson/virtual-keyboard/:slug()",
    component: () => import("/vercel/path0/pages/lesson/virtual-keyboard/[slug].vue")
  },
  {
    name: "student-lesson-exercises-slug",
    path: "/student/lesson/exercises/:slug()",
    component: () => import("/vercel/path0/pages/student/lesson/exercises/[slug].vue")
  },
  {
    name: "lesson-virtual-calculator-slug",
    path: "/lesson/virtual-calculator/:slug()",
    component: () => import("/vercel/path0/pages/lesson/virtual-calculator/[slug].vue")
  },
  {
    name: "student-certificate-course_slug",
    path: "/student/certificate/:course_slug()",
    component: () => import("/vercel/path0/pages/student/certificate/[course_slug].vue")
  },
  {
    name: "lesson-exercises-corrections-slug",
    path: "/lesson/exercises/corrections/:slug()",
    component: () => import("/vercel/path0/pages/lesson/exercises/corrections/[slug].vue")
  },
  {
    name: "student-lesson-numeric-keyboard-slug",
    path: "/student/lesson/numeric-keyboard/:slug()",
    meta: _91slug_93KQhEr5SOctE_45eR8IT7WUaMOeCYjbcMWbs5dyZGcbUFQMeta || {},
    component: () => import("/vercel/path0/pages/student/lesson/numeric-keyboard/[slug].vue")
  },
  {
    name: "student-lesson-virtual-keyboard-slug",
    path: "/student/lesson/virtual-keyboard/:slug()",
    component: () => import("/vercel/path0/pages/student/lesson/virtual-keyboard/[slug].vue")
  },
  {
    name: "student-lesson-virtual-calculator-slug",
    path: "/student/lesson/virtual-calculator/:slug()",
    meta: _91slug_93Om8NC9NrQM8xLEKk6MFdjZsUOxl5NwLsAFNgDYqut_454Meta || {},
    component: () => import("/vercel/path0/pages/student/lesson/virtual-calculator/[slug].vue")
  },
  {
    name: "user-lesson-exercises-corrections-slug",
    path: "/user/lesson/exercises/corrections/:slug()",
    component: () => import("/vercel/path0/pages/user/lesson/exercises/corrections/[slug].vue")
  },
  {
    name: "student-lesson-exercises-corrections-slug",
    path: "/student/lesson/exercises/corrections/:slug()",
    component: () => import("/vercel/path0/pages/student/lesson/exercises/corrections/[slug].vue")
  }
]